import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'block'];

  connect() {
    const storedTrack = sessionStorage.getItem(`adaptive_track_${window.location.pathname}`);
    const defaultTrack = this.buttonTargets[0]?.dataset.adaptiveFilterTrackParam;

    this.currentTrack = storedTrack || defaultTrack;

    if (this.currentTrack) {
      this.applyTrackFilter(this.currentTrack);
    }

    this.boundHandleStreamRender = this.handleStreamRender.bind(this);
    document.addEventListener('turbo:before-stream-render', this.boundHandleStreamRender);
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.boundHandleStreamRender);
  }

  handleStreamRender(event) {
    const originalRender = event.detail.render;
    event.detail.render = (streamElement) => {
      originalRender(streamElement);
      requestAnimationFrame(() => {
        this.rerender();
      });
    };
  }

  rerender() {
    if (this.currentTrack) {
      this.applyTrackFilter(this.currentTrack);
    }
  }

  set(event) {
    const track = event.params.track;

    this.currentTrack = track;
    sessionStorage.setItem(`adaptive_track_${window.location.pathname}`, track);
    this.applyTrackFilter(track);
  }

  applyTrackFilter(track) {
    this.buttonTargets.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.adaptiveFilterTrackParam === track);
    });

    this.blockTargets.forEach((block) => {
      const tracks = JSON.parse(block.dataset.tracks || '[]');
      block.classList.toggle('is-hidden', !tracks.includes(track));
    });
  }
}
